import { render, staticRenderFns } from "./Shobe.vue?vue&type=template&id=476cbdf1"
import script from "./Shobe.vue?vue&type=script&lang=js"
export * from "./Shobe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports